<template>
    <div class="timeline">
        <slot name="timeline-item-1"></slot>
        <slot name="timeline-item-2"></slot>
        <slot name="timeline-item-3"></slot>
        <slot name="timeline-item-4"></slot>
        <slot name="timeline-item-5"></slot>
        <slot name="timeline-item-6"></slot>
    </div>
</template>

<script>
    export default {
        name: 'Timeline',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .timeline{
        display: flex;
        flex-direction: column;

        align-items: center;

        @include media-breakpoint-up(sm){
            position: relative;
            flex-direction: row;
            justify-content: center;
            align-items: stretch;
            flex-wrap: wrap;

            max-width: 640px;
            margin: 0 auto;
        }

        @include media-breakpoint-up(md){
            max-width: 700px;
        }

        @include media-breakpoint-up(lg) {
            max-width: none;
        }
    }
</style>
